import { Navigate, Route, Routes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

import { AuthLayout } from '../../layouts/auth-layout';
import { Login } from '../../pages/auth/login';
import { ForgotPassword } from '../../pages/auth/forgot';

import { TutorProfile } from '../profile/tutorProfile';
import { getSession } from '../../store/auth/authActions';
import { Dashboard } from '../../pages/dashboard';
import { UsersList, AdministratorsList, TutorsModerationList, TutorModerate, CreateAdmin, RebrandAnnouncement } from '../../pages/users'
import { UserProfile } from '../../pages/users/userProfile';
import Chat from '../../pages/chat';
import { Settings } from '../../pages/settings/settings';
import { AdminAppointmentList } from '../../pages/appointment/adminList';
import { LoadingPage } from '../../pages/general/loading-page';
import { AppointmentDetails } from '../../pages/appointment/detail';
import { Wallet } from '../../pages/wallet/wallet';
import { Withdraw } from '../../pages/wallet/withdraw';
import SupportPage from '../../pages/admin/support/support';
import UserConversationsAudit from '../../pages/admin/userConversationsAudit';
import { SettingPreview } from '../../pages/settings/preview';

import { AdminNotificationsPage } from '../../pages/notifications/AdminNotificationsPage';
import { Error404 } from '../../pages/errors/404';
import AuthGuard from '../auth/auth.guard';
import { PrivateLayout } from '../../layouts';
import { AUTH_LOGIN_URL } from './routes';
import { AUTH_FORGOT_PASSWORD_URL } from './routes';


function App() {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true)
	const [isTabletScreen, setIsTabletScreen] = useState(false);
	
	useEffect(() => {
		const tabletQuery = window.matchMedia('(max-width: 1024px)');

		const updateTabletState = () => {
			setIsTabletScreen(tabletQuery.matches);
		};

		updateTabletState();
		tabletQuery.addEventListener('change', updateTabletState);

		return () => {
			tabletQuery.removeEventListener('change', updateTabletState);
		};
	}, []);

	useEffect(() => {
		dispatch(getSession())
		.unwrap()
		.then(async (data) => {
			setLoading(false)
		})
		.catch(() =>{
			setLoading(false)
		});
	}, []);

	return (
		<div>
			{loading ? <LoadingPage /> :
			isTabletScreen ? <TabletConstraintMessage /> :
			<Layout>
				<Routes>
					<Route element={<AuthGuard />}>

						<Route path={AUTH_LOGIN_URL} element={<AuthLayout restricted={true} component={Login} />} />
						<Route path={AUTH_FORGOT_PASSWORD_URL} element={<AuthLayout restricted={true} component={ForgotPassword} />} />
						
						<Route path="/" element={<PrivateLayout component={Dashboard} />} />

						<Route path='/notifications' element={<PrivateLayout restricted={true} component={AdminNotificationsPage} />} />

						<Route path='/users/list' element={<PrivateLayout restricted={true} component={UsersList} />} />
						<Route path='/users/administrators' element={<PrivateLayout restricted={true} component={AdministratorsList} />} />
						<Route path='/users/moderation' element={<PrivateLayout restricted={true} component={TutorsModerationList} />} />
						<Route path='/users/user/:userId' element={<PrivateLayout restricted={true} component={UserProfile} />} />
						<Route path='/users/moderate/:tutorId' element={<PrivateLayout restricted={true} component={TutorModerate} />} />

						
						
						<Route path='/chat' element={<PrivateLayout restricted={true} component={Chat} />} />
						<Route path='/chat/:id' element={<PrivateLayout restricted={true} component={Chat} />} />
						
						<Route path='/admin/appointment' element={<PrivateLayout restricted={true} component={AdminAppointmentList} />} />
						<Route path='/appointment/detail/:id' element={<PrivateLayout restricted={true} component={AppointmentDetails} />} />
						{/* Admin does not join video calls — no /appointment/chat route */}

						<Route path='/settings' element={<PrivateLayout restricted={true} component={Settings} />} />
						<Route path='/tutor/:id' element={<PrivateLayout restricted={true} component={TutorProfile} />} />
						<Route path='/me' element={<PrivateLayout restricted={true} component={SettingPreview} />} />
						
						<Route path='/create/admin' element={<PrivateLayout restricted={true} component={CreateAdmin} />} />
						<Route path='/users/rebrand-announcement' element={<PrivateLayout restricted={true} component={RebrandAnnouncement} />} />

						<Route path='/wallet' element={<PrivateLayout restricted={true} component={Wallet} />} />

						<Route path='/admin/support' element={<PrivateLayout restricted={true} component={SupportPage} />} />
						<Route path='/admin/user-conversations' element={<PrivateLayout restricted={true} component={UserConversationsAudit} />} />


						<Route path='/withdraw' element={<PrivateLayout restricted={true} component={Withdraw} />} />
						
						<Route path='/404' element={<PrivateLayout restricted={true} component={Error404} />} />
						<Route path="*" element={<Navigate to="/404" replace />} />
					</Route>
				</Routes>
			</Layout>}
		</div>
	);
}

const TabletConstraintMessage = () => (
	<div className="min-h-screen w-full bg-slate-100 px-4 py-8 flex items-center justify-center">
		<div className="w-full max-w-xl bg-white rounded-2xl shadow-xl border border-slate-200 p-8 text-center">
			<h1 className="text-2xl font-semibold text-slate-900 mb-4">Desktop experience only</h1>
			<p className="text-slate-600 leading-7">
				For the best UI/UX, the admin platform is currently available only on desktop screens.
				Please switch to a laptop or desktop device to continue.
			</p>
		</div>
	</div>
);

const Layout = ({ children }) => (
	<div className="">
		<div className="">
			{children}
		</div>
	</div>
);

export { App };
